import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { AffiliateSearchResultDto } from 'api/Search/Types/SearchResultDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

export const AffiliateColumnDefinition: GridColumnProps[] = [
  {
    title: 'Name',
    cell: (props: GridCellProps): JSX.Element => {
      const data = props.dataItem as AffiliateSearchResultDto
      if (!data.value) {
        return <td />
      }
      if (!data.id) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsAffiliates.detailsUrl as string, {
                id: data.id,
                slug: 'details',
              }),
            }}
          >
            {data.value}
          </Link>
        </td>
      )
    },
  },
  {
    title: 'Email',
    field: 'data.email',
  },
  {
    title: 'Country',
    field: 'data.country.name',
  },
]
